import { IResponseProcessor } from "..";

export default class SearchApi {
  constructor(
    private _baseUrl: string,
    private _getToken: (applicationId: string) => string,
    private _processor: IResponseProcessor
  ) {
    console.warn(
      "Deprecation Warning: The legacy 'SearchApi' class is in use. Please migrate to RTK Query as outlined in CONTRIBUTING.md."
    );
  }

  async search(applicationId: string, query: string): Promise<ISearchResult[]> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Search?s=${encodeURIComponent(query)}`, {
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);
    const results: ISearchResult[] = await res.json();

    return results;
  }

  async searchProduct(applicationId: string, product: string): Promise<ISearchResult> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Search/Product/${encodeURIComponent(product)}`, {
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);
    const result: ISearchResult = await res.json();

    return result;
  }

  async validateProduct(applicationId: string, RandmarSKU: string): Promise<boolean> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Search/Product/${encodeURIComponent(RandmarSKU)}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);
    return res.ok;
  }
}

export interface ISearchResult {
  ContentType: string;
  Content: any;
  Priority: string;
}


export interface IManufacturerBid {
  Active: boolean;
  LastUpdate: string;
  BidNumber: string;
  ManufacturerId: string;
  Opportunity: string;
  StartDate: string;
  EndDate: string;
}
